// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-content {
    width: auto !important;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px !important;
}

.PopupEditRoleGeolocation{
    height: 400px;
}

.popupDeleteContent {
    display: grid;
    gap: 20px;
}


.popupEditContent {
    display: grid;
    gap: 30px;
    max-height: 82vh;
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;
}


.popupEditContent::-webkit-scrollbar {
    display: none;
}



.popupEditContentFilter{
    display: grid;
    gap: 24px;
}

.popupEditHeader {
    display: flex;
    justify-content: space-between;
    padding-bottom: 12px;
    border-bottom: 1px solid rgb(232, 223, 213, .5);
}

.popupDeleteHeader {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgb(232, 223, 213, .5);
}

.popupMainEditContent {
    display: grid;
    gap: 20px;
    justify-content: center;
}

.popupMainEditContent label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42 !important;
}

.popupMainEditContent input {
    background: #FFFFFF;
    border: 1px solid #E8DFD5;
    border-radius: 8px;
    height: 40px;
    width: 320px;
    padding: 15px;
}


.popupMainEditContent input:focus-visible {
    outline: none;
}

.popupMainEditContent>.EditImage {
    align-items: center;
    justify-content: center;
    display: flex;
}

.popupDeleteHeader span {
    color: #3F3325;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
}

.popupEditHeader span {
    color: #3F3325;
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
}


.popupDeleteHeader img {
    cursor: pointer;
}



.popupEditHeader img {
    cursor: pointer;
}

.popupMainContent span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
}

.popupMainEditContent>.EditField {
    display: grid;
    gap:4px
}

.popupDeleteButtonFilter{
    display: flex;
    margin-top: 10px;
    gap: 20px;
}

.popupDeleteButtonFilter>.CancelButton {
    width: 185px;
    height: 40px;
    background: #EDF3F2 ;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    color: #38514C;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.popupDeleteButtonFilter>.DeleteButton {
    width: 185px;
    height: 40px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    background: #E67817;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.disableddelete{
    width: 152px;
    height: 40px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    background: #FAE4D1;
}

.popupDeleteButtonUsers{
    display: flex;
    margin-top: 10px;
    gap: 16px;
}

.popupDeleteButtonUsers>.CancelButton{
    width: 152px;
    height: 40px;
    background: #EDF3F2 ;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    color: #38514C;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}
.popupDeleteButtonUsers>.DeleteButton {
    width: 152px;
    height: 40px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    background: #E67817;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.popupDeleteButton {
    display: flex;
    margin-top: 10px;
    gap: 20px;
}

.popupDeleteButton>.CancelButton {
    width: 166px;
    height: 40px;
    background: #EDF3F2 ;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    color: #38514C;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}


.popupDeleteButton>.DeleteButton {
    width: 166px;
    height: 40px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    background: #E67817;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}

.GeolocationEditContent {
    display: grid;
    row-gap: 24px;
    column-gap: 16px;
    grid-template-columns: 50% 50%;
}

.GeolocationEditContent>.EditField {
    display: grid;
    gap: 4px;
}

.GeolocationEditContent input {
    background: #FFFFFF;
    border: 1px solid #E8DFD5;
    border-radius: 8px;
    height: 40px;
    width: 168px;
    padding: 15px;
}

.GeolocationEditContent input:focus-visible {
    outline: none;
}

.GeolocationEditContent label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
}


.GeolocationFilterContent {
    display: flex;
    width: 400px;
}


.GeolocationFilterContent ul {
    list-style: none;
}



.GeolocationFilterContent {
    border-bottom: 1px solid rgb(232, 223, 213, .5);

}

.FilterSidebar {
    width: 40%;
    border-right: 1px solid rgb(232, 223, 213, .5);
}

.FilterSidebar>ul {
    background: #FFF3E8 ;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-right: 2px solid #FF8214;
}

.not_active {
    background: white !important;
    border-right: none !important;
}

.FilterList {
    width: 60%;
    max-width: 269px;
}

.FilterSidebar>ul>li>span {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #3F3325;
}

.checkbox {
    cursor: pointer;
}

.FilterList>ul {
    padding: 12px;
}


.Setting_Upload_Button>input {
    display: none;
}

.FilterList>ul>li {
    margin-bottom: 20px;
}

.FilterList>ul>li>div {
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
}

.FilterList ul span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #3F3325;
}

.filterListData {
    display: flex;
    align-items: flex-start !important;
    flex-direction: column;
    max-height: 200px;
    overflow-y: auto;
    gap: 20px;
    cursor: auto !important;
    ;
    margin-top: 10px;
    margin-bottom: 10px;
}


.filterListData::-webkit-scrollbar {
    width: 6px;
    height: 72px;
}


::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-radius: 10px;
}



.filterListData>div {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 2px;
}


.map_upload_settings {
    background: #FFFFFF;
    border: 1px dashed #E8DFD5;
    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);
    border-radius: 8px;
    width: 508px;
    height: 451px;
}

.setting_map_upload {
    width: 508px;
    display: grid;
}

.map_upload_img {
    width: 200px;
    height: 200px;
    margin: auto;
}

.map_upload_img>img {
    width: inherit;
    height: inherit;
}

.map_input {
    display: flex;
    flex-direction: column;
}


.map_input>label {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
}

.map_input>input {
    border: 2px solid #E8DFD5;
    border-radius: 8px;
    width: 50%;
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    padding: 0.6rem;
    background: #FFFF;
    line-height: 20px;
}

.map_input>input:focus-visible {
    outline: none;
}

.map_upload {
    display: flex;
    margin-top: 20px;
    justify-content: center;
    align-items: center;
    gap: 20px;
    border: 1px dashed #E8DFD5;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 20px;
}

.map_upload_heading {
    display: grid;
}

.map_upload_main_heading {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #3F3325;
}

.map_upload_text {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #9A938A;
}

.map_upload_excel_button {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    width: 106px;
    height: 34px;
    background: rgba(72, 136, 123, 0.1);
    border-radius: 8px;
    color: #38514C;
    cursor: pointer;
    outline: none;
    border: none;
}

.map_uploaded_file {
    display: grid;
    margin-top: 20px;
    margin-bottom: 20px;
    gap: 10px;
}

.map_uploaded_area {
    width: 508px;
    height: 56px;
    left: 24px;
    top: 493px;
    background: #FCF9F7;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.map_upload_file_heading>span {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42;
}

.map_uploaded_area>span {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #594F42;
}

.setting_map_button{
    margin-left: 70%;
    visibility:hidden;
}

.setting_map:hover .setting_map_button{
    visibility: visible;
}

.PopupRadioButton{
    display: flex;
    gap: 10px;
}

.PopupRadioButton>span{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #594F42 !important;
}

.PopupRadioButton>#role{
    cursor: pointer;
    accent-color: #48887B;
}


.PopupRadioButton>input{
    cursor: pointer;
    accent-color: #48887B;
}

.footer {
  display: flex;
  justify-content: flex-end;

}

.DeleteButton {
  width: 166px;
  height: 30px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: #E67817;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;

}


.IdentifyButton {
  width: 166px;
  padding: 0.5rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: #E67817;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;

}

.Identified {
    margin-bottom: 0px;
  }

.MatchingButton {
  width: 166px;
  height: 40px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: #EDF3F2;
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;

}


.modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.iconContainer {
  display: flex;
  align-items: center;
  margin-bottom: -80px;
}
.icon {
  margin-right: 5px;
}

.textContainer {
  display: flex;
  align-items: center;
  margin-bottom: -20px;
  margin-left: 20px;
  
}

.dropdownContainer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
}

.DropdownMenu{
    border: 1px solid #E8DFD5;
    border-radius: 8px;
    min-width: 200px;
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    padding: 0.6rem;
    background: #FFFF;
    line-height: 20px;
    cursor: pointer;
    margin-bottom: 10px;
}

@media screen and (max-width: 600px) {
  .dropdownContainer {
    flex-direction: column;
    align-items: flex-start;
  }

  .DropdownMenu {
    width: 100%; 
    margin-bottom: 15px;
  }

  .DeleteButton {
    width: 100%;
  }
}

.body {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
}

.half {
  width: 49%;
   box-sizing: border-box;
    border-radius: 10px;
    position:relative;
}

.half .image-container {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.half img {
  width: 100%;
  height: auto;
   border-radius: 10px;
   display: block;
}

.half .arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px; /* Adjust arrow width */
  height: auto;
  cursor: pointer;
  z-index: 1;
}

.half_2 {
  width: 20%;
   box-sizing: border-box;
    border-radius: 10px;
    position:relative;
}

.half_2 .image-container {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.half_2 img {
  width: 100%;
  height: auto;
   border-radius: 10px;
   display: block;
}


.control-btn{
    padding: 1.3vh 1vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border-color: transparent;
    font-size: 0.75rem;
    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}


.dropdownContainer_Tiger{
    display: flex;
    flex-direction: column;
    align-items: end;
    margin-top: -20vh;
}

.control-btn-container{
    display: flex;
    align-items: center;
    gap: 1vw;
    justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/CSS/Popup.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;;AAGA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB;AACzB;;;AAGA;IACI,aAAa;AACjB;;;;AAIA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,eAAe;AACnB;;;;AAIA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,YAAY;AAChB;;;AAGA;IACI,gBAAgB;AACpB;;;;AAIA;IACI,+CAA+C;;AAEnD;;AAEA;IACI,UAAU;IACV,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,uBAAuB;;IAEvB,gBAAgB;IAChB,mBAAmB;AACvB;;;AAGA;IACI,UAAU;IACV,YAAY;AAChB;;;AAGA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;;;AAIA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;;AAGA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,gDAAgD;IAChD,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;;AAGA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;;AAE3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;;AAErB;;;AAGA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;;AAErB;;AAEA;IACI,kBAAkB;EACpB;;AAEF;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;;AAErB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;;AAEnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;GACT,sBAAsB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;GACX,mBAAmB;GACnB,cAAc;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW,EAAE,uBAAuB;EACpC,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;GACT,sBAAsB;IACrB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;GACX,mBAAmB;GACnB,cAAc;AACjB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,4EAA4E;AAChF;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;AAClC","sourcesContent":[".popup-content {\n    width: auto !important;\n    background: #FFFFFF;\n    border-radius: 8px;\n    padding: 20px !important;\n}\n\n.PopupEditRoleGeolocation{\n    height: 400px;\n}\n\n.popupDeleteContent {\n    display: grid;\n    gap: 20px;\n}\n\n\n.popupEditContent {\n    display: grid;\n    gap: 30px;\n    max-height: 82vh;\n    overflow-y: scroll;\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;\n}\n\n\n.popupEditContent::-webkit-scrollbar {\n    display: none;\n}\n\n\n\n.popupEditContentFilter{\n    display: grid;\n    gap: 24px;\n}\n\n.popupEditHeader {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 12px;\n    border-bottom: 1px solid rgb(232, 223, 213, .5);\n}\n\n.popupDeleteHeader {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px solid rgb(232, 223, 213, .5);\n}\n\n.popupMainEditContent {\n    display: grid;\n    gap: 20px;\n    justify-content: center;\n}\n\n.popupMainEditContent label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42 !important;\n}\n\n.popupMainEditContent input {\n    background: #FFFFFF;\n    border: 1px solid #E8DFD5;\n    border-radius: 8px;\n    height: 40px;\n    width: 320px;\n    padding: 15px;\n}\n\n\n.popupMainEditContent input:focus-visible {\n    outline: none;\n}\n\n.popupMainEditContent>.EditImage {\n    align-items: center;\n    justify-content: center;\n    display: flex;\n}\n\n.popupDeleteHeader span {\n    color: #3F3325;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n}\n\n.popupEditHeader span {\n    color: #3F3325;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 28px;\n}\n\n\n.popupDeleteHeader img {\n    cursor: pointer;\n}\n\n\n\n.popupEditHeader img {\n    cursor: pointer;\n}\n\n.popupMainContent span {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n}\n\n.popupMainEditContent>.EditField {\n    display: grid;\n    gap:4px\n}\n\n.popupDeleteButtonFilter{\n    display: flex;\n    margin-top: 10px;\n    gap: 20px;\n}\n\n.popupDeleteButtonFilter>.CancelButton {\n    width: 185px;\n    height: 40px;\n    background: #EDF3F2 ;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    color: #38514C;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.popupDeleteButtonFilter>.DeleteButton {\n    width: 185px;\n    height: 40px;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    background: #E67817;\n    color: #FFFFFF;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.disableddelete{\n    width: 152px;\n    height: 40px;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    color: #FFFFFF;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    background: #FAE4D1;\n}\n\n.popupDeleteButtonUsers{\n    display: flex;\n    margin-top: 10px;\n    gap: 16px;\n}\n\n.popupDeleteButtonUsers>.CancelButton{\n    width: 152px;\n    height: 40px;\n    background: #EDF3F2 ;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    color: #38514C;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n.popupDeleteButtonUsers>.DeleteButton {\n    width: 152px;\n    height: 40px;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    background: #E67817;\n    color: #FFFFFF;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.popupDeleteButton {\n    display: flex;\n    margin-top: 10px;\n    gap: 20px;\n}\n\n.popupDeleteButton>.CancelButton {\n    width: 166px;\n    height: 40px;\n    background: #EDF3F2 ;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    color: #38514C;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n\n.popupDeleteButton>.DeleteButton {\n    width: 166px;\n    height: 40px;\n    border-radius: 8px;\n    border: none;\n    cursor: pointer;\n    background: #E67817;\n    color: #FFFFFF;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.GeolocationEditContent {\n    display: grid;\n    row-gap: 24px;\n    column-gap: 16px;\n    grid-template-columns: 50% 50%;\n}\n\n.GeolocationEditContent>.EditField {\n    display: grid;\n    gap: 4px;\n}\n\n.GeolocationEditContent input {\n    background: #FFFFFF;\n    border: 1px solid #E8DFD5;\n    border-radius: 8px;\n    height: 40px;\n    width: 168px;\n    padding: 15px;\n}\n\n.GeolocationEditContent input:focus-visible {\n    outline: none;\n}\n\n.GeolocationEditContent label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n}\n\n\n.GeolocationFilterContent {\n    display: flex;\n    width: 400px;\n}\n\n\n.GeolocationFilterContent ul {\n    list-style: none;\n}\n\n\n\n.GeolocationFilterContent {\n    border-bottom: 1px solid rgb(232, 223, 213, .5);\n\n}\n\n.FilterSidebar {\n    width: 40%;\n    border-right: 1px solid rgb(232, 223, 213, .5);\n}\n\n.FilterSidebar>ul {\n    background: #FFF3E8 ;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-right: 2px solid #FF8214;\n}\n\n.not_active {\n    background: white !important;\n    border-right: none !important;\n}\n\n.FilterList {\n    width: 60%;\n    max-width: 269px;\n}\n\n.FilterSidebar>ul>li>span {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #3F3325;\n}\n\n.checkbox {\n    cursor: pointer;\n}\n\n.FilterList>ul {\n    padding: 12px;\n}\n\n\n.Setting_Upload_Button>input {\n    display: none;\n}\n\n.FilterList>ul>li {\n    margin-bottom: 20px;\n}\n\n.FilterList>ul>li>div {\n    display: flex;\n    cursor: pointer;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.FilterList ul span {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #3F3325;\n}\n\n.filterListData {\n    display: flex;\n    align-items: flex-start !important;\n    flex-direction: column;\n    max-height: 200px;\n    overflow-y: auto;\n    gap: 20px;\n    cursor: auto !important;\n    ;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n\n.filterListData::-webkit-scrollbar {\n    width: 6px;\n    height: 72px;\n}\n\n\n::-webkit-scrollbar-thumb {\n    background: #D9D9D9;\n    border-radius: 10px;\n}\n\n\n\n.filterListData>div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    padding: 2px;\n}\n\n\n.map_upload_settings {\n    background: #FFFFFF;\n    border: 1px dashed #E8DFD5;\n    box-shadow: 0px 4px 16px rgba(148, 93, 63, 0.05);\n    border-radius: 8px;\n    width: 508px;\n    height: 451px;\n}\n\n.setting_map_upload {\n    width: 508px;\n    display: grid;\n}\n\n.map_upload_img {\n    width: 200px;\n    height: 200px;\n    margin: auto;\n}\n\n.map_upload_img>img {\n    width: inherit;\n    height: inherit;\n}\n\n.map_input {\n    display: flex;\n    flex-direction: column;\n}\n\n\n.map_input>label {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n}\n\n.map_input>input {\n    border: 2px solid #E8DFD5;\n    border-radius: 8px;\n    width: 50%;\n    height: 40px;\n    font-weight: 400;\n    font-size: 14px;\n    padding: 0.6rem;\n    background: #FFFF;\n    line-height: 20px;\n}\n\n.map_input>input:focus-visible {\n    outline: none;\n}\n\n.map_upload {\n    display: flex;\n    margin-top: 20px;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    border: 1px dashed #E8DFD5;\n    border-radius: 10px;\n    padding: 10px;\n    margin-bottom: 20px;\n}\n\n.map_upload_heading {\n    display: grid;\n}\n\n.map_upload_main_heading {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: #3F3325;\n}\n\n.map_upload_text {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 18px;\n    color: #9A938A;\n}\n\n.map_upload_excel_button {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    width: 106px;\n    height: 34px;\n    background: rgba(72, 136, 123, 0.1);\n    border-radius: 8px;\n    color: #38514C;\n    cursor: pointer;\n    outline: none;\n    border: none;\n}\n\n.map_uploaded_file {\n    display: grid;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    gap: 10px;\n}\n\n.map_uploaded_area {\n    width: 508px;\n    height: 56px;\n    left: 24px;\n    top: 493px;\n    background: #FCF9F7;\n    border-radius: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.map_upload_file_heading>span {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42;\n}\n\n.map_uploaded_area>span {\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: #594F42;\n}\n\n.setting_map_button{\n    margin-left: 70%;\n    visibility:hidden;\n}\n\n.setting_map:hover .setting_map_button{\n    visibility: visible;\n}\n\n.PopupRadioButton{\n    display: flex;\n    gap: 10px;\n}\n\n.PopupRadioButton>span{\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #594F42 !important;\n}\n\n.PopupRadioButton>#role{\n    cursor: pointer;\n    accent-color: #48887B;\n}\n\n\n.PopupRadioButton>input{\n    cursor: pointer;\n    accent-color: #48887B;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n\n}\n\n.DeleteButton {\n  width: 166px;\n  height: 30px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  background: #E67817;\n  color: #FFFFFF;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 10px;\n\n}\n\n\n.IdentifyButton {\n  width: 166px;\n  padding: 0.5rem;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  background: #E67817;\n  color: #FFFFFF;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 10px;\n\n}\n\n.Identified {\n    margin-bottom: 0px;\n  }\n\n.MatchingButton {\n  width: 166px;\n  height: 40px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  background: #EDF3F2;\n  color: #000000;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 10px;\n\n}\n\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: -80px;\n}\n.icon {\n  margin-right: 5px;\n}\n\n.textContainer {\n  display: flex;\n  align-items: center;\n  margin-bottom: -20px;\n  margin-left: 20px;\n  \n}\n\n.dropdownContainer {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.DropdownMenu{\n    border: 1px solid #E8DFD5;\n    border-radius: 8px;\n    min-width: 200px;\n    height: 40px;\n    font-weight: 400;\n    font-size: 14px;\n    padding: 0.6rem;\n    background: #FFFF;\n    line-height: 20px;\n    cursor: pointer;\n    margin-bottom: 10px;\n}\n\n@media screen and (max-width: 600px) {\n  .dropdownContainer {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .DropdownMenu {\n    width: 100%; \n    margin-bottom: 15px;\n  }\n\n  .DeleteButton {\n    width: 100%;\n  }\n}\n\n.body {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.half {\n  width: 49%;\n   box-sizing: border-box;\n    border-radius: 10px;\n    position:relative;\n}\n\n.half .image-container {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.half img {\n  width: 100%;\n  height: auto;\n   border-radius: 10px;\n   display: block;\n}\n\n.half .arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 36px; /* Adjust arrow width */\n  height: auto;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.half_2 {\n  width: 20%;\n   box-sizing: border-box;\n    border-radius: 10px;\n    position:relative;\n}\n\n.half_2 .image-container {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.half_2 img {\n  width: 100%;\n  height: auto;\n   border-radius: 10px;\n   display: block;\n}\n\n\n.control-btn{\n    padding: 1.3vh 1vw;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n    border-color: transparent;\n    font-size: 0.75rem;\n    transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n\n\n.dropdownContainer_Tiger{\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n    margin-top: -20vh;\n}\n\n.control-btn-container{\n    display: flex;\n    align-items: center;\n    gap: 1vw;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
